/* ==========================================================
   ALLBUY · לוגיקת ערכת העיצוב לשופיפיי
   סל נפתח (Cart AJAX API) עם התקדמות למשלוח חינם והצעת מוצרים, בחירת וריאציה,
   הוספה מהירה, גלריה, פס קנייה דביק, מגירות, מועדון, פניות וביקורות.
   ========================================================== */
(function () {
  'use strict';

  const P = window.PELLENA || {};
  const S = P.strings || {};
  // תרגומים מגיעים מקודדים ל-HTML (למשל &#39; במקום גרש): מפענחים פעם אחת, כי בהמשך הם עוברים קידוד בטוח
  const decoder = document.createElement('textarea');
  Object.keys(S).forEach(k => { if (typeof S[k] === 'string') { decoder.innerHTML = S[k]; S[k] = decoder.value; } });
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ESC[c]);
  const sized = (url, w) => (url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : '');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- בלאק פריידיי (snippets/bf-config.liquid, מרונדר ב-sections/header.liquid) ----------
     נדלק ונכבה לבד לפי התאריכים, לפי השעון בדפדפן (גם כשהעמוד הגיע מהמטמון של שופיפיי).
     ב-PELLENA מדרגה אחת: 15% על כל פריט מאוסף המבצע (ההנחה האוטומטית "Black Friday 15%"), בלי מבצעי כמות.
     ההנחה לא מצטרפת לשום הנחה אחרת (גם לא ל-PELLENA10): שופיפיי נותנת את הטובה מביניהן. */
  try { const c = $('script[data-bf-config]'); P.bf = c ? JSON.parse(c.textContent) : null; } catch (e) { P.bf = null; }
  if (P.bf && P.bf.line) { decoder.innerHTML = P.bf.line; P.bf.line = decoder.value; }
  function bfLive() { const B = P.bf, now = Date.now(); return !!B && now >= B.start && now <= B.end; }

  /* ---------- כסף: לפי פורמט החנות, בלי אגורות מיותרות ----------
     ללקוחות מחו"ל: בדולרים לפי השער שבהגדרות (התשלום עצמו בשקלים, זהה ל-snippets/money.liquid) */
  function formatMoney(cents) {
    if (P.usdRate > 0) {
      // מחיר "עגול" שמסתיים ב-.99, מעוגל כלפי מעלה (זהה ל-snippets/money.liquid)
      const usd = Math.ceil(cents / P.usdRate / 100) - 0.01;
      return '$' + usd.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    return formatIls(cents);
  }
  function formatIls(cents) {
    // תמיד "1,299 ₪", לא תלוי בפורמט המטבע שבניהול (זהה ל-snippets/money.liquid)
    const fmt = '{{amount}} ₪';
    const re = /\{\{\s*(\w+)\s*\}\}/;
    const m = fmt.match(re);
    const group = (n, dec, thousands, decimal) => {
      const parts = (n / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };
    if (!m) return fmt;
    let v;
    switch (m[1]) {
      case 'amount_no_decimals': v = group(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = group(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = group(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = group(cents, 2, "'", '.'); break;
      default: v = group(cents, 2, ',', '.');
    }
    v = v.replace(/[.,]00$/, '');
    return fmt.replace(re, v).replace(/<[^>]*>/g, '');
  }
  function priceHTML(price, compare, big) {
    const sale = compare && compare > price;
    return `<span class="price${big ? ' price--lg' : ''}${sale ? ' price--sale' : ''}"><span class="price__now">${formatMoney(price)}</span>` +
      (sale ? `<s class="price__was">${formatMoney(compare)}</s>` : '') +
      (sale && big ? `<span class="price__save">${esc(S.save).replace('__AMOUNT__', formatMoney(compare - price))}</span>` : '') + '</span>';
  }

  /* ---------- ימי עסקים בישראל (א׳ עד ה׳) ---------- */
  function dispatchDate() {
    const d = new Date();
    let added = 0;
    while (added < (P.dispatchDays || 3)) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 5 && d.getDay() !== 6) added++;
    }
    if (P.locale === 'he') return 'יום ' + ['א׳', 'ב׳', 'ג׳', 'ד׳', 'ה׳', 'ו׳', 'ש׳'][d.getDay()] + ', ' + d.getDate() + '.' + (d.getMonth() + 1);
    return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
  }

  /* ---------- צבעים (זהה ל-snippets/swatch-color.liquid) ---------- */
  const SWATCH = {
    'לבן': '#FFFFFF', white: '#FFFFFF', 'שחור': '#22272A', black: '#22272A', 'אפור': '#9097A0', grey: '#9097A0', gray: '#9097A0',
    'אדום': '#E5484D', red: '#E5484D', 'ירוק': '#2FA36B', green: '#2FA36B', 'כחול': '#36B5B8', blue: '#36B5B8', 'טורקיז': '#36B5B8',
    'ורוד': '#F2A7B8', pink: '#F2A7B8', 'צהוב': '#F6C343', yellow: '#F6C343', 'כתום': '#B81FC4', orange: '#B81FC4',
    'סגול': '#8E6BD8', purple: '#8E6BD8', 'חום': '#8B5E3C', brown: '#8B5E3C', "בז'": '#E3D3BC', beige: '#E3D3BC'
  };
  /* שם אפשרות בלי אימוג'י: "🔴 אדום" ← "אדום" (סוגריים, מקפים ומספרים נשארים) */
  const clean = v => String(v || '').replace(/[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{2B00}-\u{2BFF}️‍]/gu, '').replace(/\s+/g, ' ').trim();
  const swatchHex = v => SWATCH[clean(v).toLowerCase()] || '#E9DCCB';
  const isColorName = n => /color|colour|צבע|גוון/i.test(n || '');

  const ICON = {
    plus: '<svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M12 5.5v13M5.5 12h13"/></svg>',
    minus: '<svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M5.5 12h13"/></svg>',
    lock: '<svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="10.5" width="14" height="10" rx="2"/><path d="M8 10.5V7.8a4 4 0 0 1 8 0v2.7"/></svg>',
    bag: '<svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5.2 8.5h13.6l-1.1 11.2a1.5 1.5 0 0 1-1.5 1.3H7.8a1.5 1.5 0 0 1-1.5-1.3z"/><path d="M8.8 8.5V7a3.2 3.2 0 0 1 6.4 0v1.5"/></svg>'
  };

  /* ---------- מגירות ---------- */
  let lastFocus = null;
  function openPanel(id) {
    const el = document.getElementById(id);
    if (!el) return;
    closePanels(true);
    lastFocus = lastFocus || document.activeElement;
    el.inert = false;
    el.classList.add('is-open');
    const o = $('[data-overlay]');
    if (o) o.classList.add('is-open');
    document.body.classList.add('lock');
    setTimeout(() => { const b = $('[data-close]', el); if (b) b.focus(); }, 60);
  }
  function closePanels(silent) {
    $$('.drawer.is-open').forEach(el => { el.classList.remove('is-open'); el.inert = true; });
    const o = $('[data-overlay]');
    if (o) o.classList.remove('is-open');
    document.body.classList.remove('lock');
    if (!silent) { if (lastFocus && lastFocus.focus) lastFocus.focus(); lastFocus = null; }
  }
  let toastTimer;
  function toast(msg) {
    const t = $('[data-toast]');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('is-on'), 3000);
  }

  /* ---------- סל (Cart AJAX API) ---------- */
  const json = { Accept: 'application/json', 'Content-Type': 'application/json' };
  const getCart = () => fetch(P.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
  async function addItem(id, quantity) {
    const r = await fetch(P.routes.cartAdd + '.js', { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity || 1 }] }) });
    if (!r.ok) {
      const e = await r.json().catch(() => ({}));
      throw new Error(e.description || e.message || S.error);
    }
    return r.json();
  }
  const changeLine = (key, quantity) =>
    fetch(P.routes.cartChange + '.js', { method: 'POST', headers: json, body: JSON.stringify({ id: key, quantity }) }).then(r => r.json());

  let upsellList = [];
  try { const u = $('[data-upsell-json]'); if (u) upsellList = JSON.parse(u.textContent) || []; } catch (e) { upsellList = []; }
  /* אחרי הוספה לסל: ההצעות מתעדכנות למוצרים המשלימים של מה שנוסף (sections/cart-upsell.liquid) */
  async function loadUpsell() {
    try {
      const r = await fetch(P.routes.root.replace(/\/?$/, '/') + '?sections=cart-upsell', { headers: { Accept: 'application/json' } });
      const html = (await r.json())['cart-upsell'] || '';
      const m = html.match(/<script[^>]*data-upsell-json[^>]*>([\s\S]*?)<\/script>/);
      if (m) upsellList = JSON.parse(m[1]) || upsellList;
    } catch (e) { /* ההצעות הקודמות נשארות */ }
  }


  /* בלאק פריידיי בסל: תגית בשורה שההנחה "Black Friday" באמת חלה עליה, לפי הסל של שופיפיי (לא לפי תאריך; זהה ל-sections/main-cart) */
  function bfLine(item) {
    if (!P.bf || !P.bf.line || !item.original_line_price) return '';
    const amt = (item.line_level_discount_allocations || [])
      .filter(a => /black[\s-]*friday/i.test((a.discount_application || {}).title || ''))
      .reduce((s, a) => s + (a.amount || 0), 0);
    const pct = Math.round(amt * 100 / item.original_line_price);
    return pct > 0 ? `<p class="bf-line">${esc(P.bf.line.replace('__P__', pct))}</p>` : '';
  }

  function lineHTML(item) {
    const options = (item.options_with_values || []).filter(o => o.name !== 'Title').map(o => clean(o.value));
    const media = item.image ? `<img src="${esc(sized(item.image, 200))}" alt="" loading="lazy">` : '';
    return `
<div class="line-item">
  <a class="line-item__media" href="${esc(item.url)}" tabindex="-1" aria-hidden="true">${media}</a>
  <div>
    <h3><a href="${esc(item.url)}">${esc(item.product_title)}</a></h3>
    ${options.length ? `<p class="meta"><bdi>${options.map(esc).join(' · ')}</bdi></p>` : ''}
    ${bfLine(item)}
    <div class="qty" data-key="${esc(item.key)}">
      <button type="button" data-qty="1" aria-label="${esc(S.qtyUp)}">${ICON.plus}</button>
      <span aria-label="${esc(S.quantity)}">${item.quantity}</span>
      <button type="button" data-qty="-1" aria-label="${esc(S.qtyDown)}">${ICON.minus}</button>
    </div>
    <button type="button" class="remove" data-remove="${esc(item.key)}">${esc(S.remove)}</button>
  </div>
  <span class="line-item__price">${item.original_line_price > item.final_line_price ? `<s>${formatMoney(item.original_line_price)}</s>` : ''}${formatMoney(item.final_line_price)}</span>
</div>`;
  }

  function upsellHTML(cart) {
    const inCart = new Set(cart.items.map(i => i.handle));
    const picks = upsellList.filter(p => !inCart.has(p.handle)).slice(0, 2);
    if (!picks.length) return '';
    return `<div class="upsell"><h3>${esc(S.upsellTitle)}</h3>` + picks.map(p => `
<div class="upsell__item">
  <a class="upsell__media" href="${esc(p.url)}" tabindex="-1" aria-hidden="true">${p.image ? `<img src="${esc(p.image)}" alt="" loading="lazy">` : ''}</a>
  <div><b>${esc(p.title)}</b>${priceHTML(p.price, p.compare)}</div>
  <button class="btn btn--primary btn--sm" type="button" ${p.multi ? `data-quick="${esc(p.handle)}"` : `data-add-variant="${p.id}"`} aria-label="${esc(S.upsellAdd)}: ${esc(p.title)}">${ICON.plus} ${esc(S.upsellAdd)}</button>
</div>`).join('') + '</div>';
  }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count || ''; el.toggleAttribute('data-zero', !cart.item_count); });
    const body = $('[data-cart-body]'), foot = $('[data-cart-foot]');
    if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = `<div class="empty"><span class="empty__icon">${ICON.bag}</span><p>${esc(S.empty)}</p><a class="btn btn--primary" href="${esc(P.routes.all)}">${esc(S.explore)}</a></div>` + upsellHTML(cart);
      foot.hidden = true;
      return;
    }
    // פס ההתקדמות למשלוח חינם מוצג רק כשיש סף משלוח חינם (בישראל). בחו"ל המשלוח מחושב בקופה
    const hasFree = (P.freeShipping || 0) > 0;
    const left = hasFree ? P.freeShipping - cart.total_price : 1;
    const progress = left > 0 ? esc(S.toFree).replace('__AMOUNT__', `<b>${formatMoney(left)}</b>`) : esc(S.free);
    const pct = hasFree ? Math.min(100, (cart.total_price / P.freeShipping) * 100) : 0;
    body.innerHTML = (hasFree ? `<div class="ship-progress">${progress}<div class="bar"><i style="--p:${pct}%"></i></div></div>` : '') + cart.items.map(lineHTML).join('') + upsellHTML(cart);
    foot.hidden = false;
    const saved = cart.total_discount || 0;
    foot.innerHTML = (saved > 0 ? `<div class="totals totals--saved"><span>${esc(S.saved)}</span><span>−${formatMoney(saved)}</span></div>` : '') + `
<div class="totals"><span>${esc(S.total)}</span><span class="totals__price">${formatMoney(cart.total_price)}</span></div>
<p class="totals-note">${esc(left > 0 ? S.taxesShipping : S.taxesFree)}</p>${foot.dataset.ilsNote ? `<p class="totals-note" dir="ltr" style="margin-top:-10px;font-size:.78rem">${esc(foot.dataset.ilsNote)}</p>` : ''}
<form action="${esc(P.routes.cart)}" method="post"><button class="btn btn--primary btn--lg btn--block" type="submit" name="checkout">${ICON.lock} ${esc(S.checkout)}</button></form>
<p class="foot-note">${esc(S.shipsNote)} ${esc(dispatchDate())} · ${esc(S.cartNote)}</p>`;
  }

  async function refreshCart(open, withUpsell) {
    try {
      const [cart] = await Promise.all([getCart(), withUpsell ? loadUpsell() : null]);
      renderCart(cart);
      if (open) openPanel('cart');
    } catch (e) { console.error(e); }
  }
  function bumpCount() {
    $$('[data-cart-count]').forEach(el => { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); });
  }
  async function addAndOpen(id, quantity, btn) {
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    try {
      await addItem(id, quantity);
      await refreshCart(true, true);
      bumpCount();
    } catch (e) {
      toast(e.message || S.error);
    } finally {
      if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
    }
  }

  /* ---------- בחירת וריאציה (עמוד מוצר והוספה מהירה) ---------- */
  function initPicker(scope, product, onVariant) {
    const fieldsets = $$('[data-option-index]', scope);
    const update = () => {
      const selected = fieldsets.map(fs => { const c = $('input:checked', fs); return c ? c.value : null; });
      fieldsets.forEach((fs, i) => { const lab = $('[data-option-label]', fs); if (lab) lab.textContent = clean(selected[i]); });
      const variant = fieldsets.length ? product.variants.find(v => v.options.every((o, i) => o === selected[i])) : product.variants[0];
      const idInput = $('[data-variant-id]', scope), btn = $('button[type="submit"]', scope);
      const label = btn && ($('[data-cta-label]', btn) || btn);
      if (btn) {
        if (!variant) { btn.disabled = true; label.textContent = S.unavailable; }
        else { btn.disabled = !variant.available; label.textContent = variant.available ? S.addToCart : S.soldOut; }
      }
      if (variant && idInput) idInput.value = variant.id;
      if (onVariant) onVariant(variant, selected);
    };
    scope.addEventListener('change', e => { if (e.target.closest('[data-option-index]')) update(); });
    return update;
  }

  /* ---------- הוספה מהירה מכרטיס מוצר ---------- */
  async function openQuick(handle) {
    const body = $('[data-quick-body]');
    if (!body) return;
    try {
      const p = await fetch(P.routes.root.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
      const variant = p.variants.find(v => v.available) || p.variants[0];
      const options = (p.options || []).map((o, i) => (typeof o === 'string' ? { name: o, values: [...new Set(p.variants.map(v => v.options[i]))] } : o))
        .filter(o => !(o.name === 'Title' && o.values.length === 1));
      const mediaFor = v => {
        const img = (v && v.featured_image && v.featured_image.src) || p.featured_image;
        return img ? `<img src="${esc(sized(img, 300))}" alt="">` : '';
      };
      body.innerHTML = `
<div class="quick__product">
  <span class="quick__media" data-quick-media>${mediaFor(variant)}</span>
  <div><h3>${esc(p.title)}</h3><div data-quick-price>${priceHTML(variant.price, variant.compare_at_price)}</div></div>
</div>
<form class="buy" data-quick-form novalidate>
  <input type="hidden" data-variant-id value="${variant.id}">
  ${options.map((o, i) => `
  <fieldset class="opt-group" data-option-index="${i}">
    <legend>${esc(clean(o.name))}: <b data-option-label>${esc(clean(variant.options[i]))}</b></legend>
    <div class="pills">${o.values.map(val => `<label class="pill"><input type="radio" name="q-option-${i}" value="${esc(val)}"${val === variant.options[i] ? ' checked' : ''}><span>${isColorName(o.name) ? `<i class="pill__dot" style="--sw:${swatchHex(val)}"></i>` : ''}${esc(clean(val))}</span></label>`).join('')}</div>
  </fieldset>`).join('')}
  <button class="btn btn--primary btn--lg btn--block" type="submit">${ICON.bag} <span data-cta-label>${esc(S.addToCart)}</span></button>
</form>
<div class="quick__more"><a class="link-cta" href="${esc(p.url)}">${esc(S.moreDetails)}</a></div>`;
      const form = $('[data-quick-form]', body);
      initPicker(form, p, v => {
        if (!v) return;
        $('[data-quick-media]', body).innerHTML = mediaFor(v);
        $('[data-quick-price]', body).innerHTML = priceHTML(v.price, v.compare_at_price);
      })();
      form.addEventListener('submit', e => { e.preventDefault(); addAndOpen($('[data-variant-id]', form).value, 1, $('button[type="submit"]', form)); });
      openPanel('quick');
    } catch (e) {
      console.error(e);
      location.href = P.routes.root.replace(/\/?$/, '/') + 'products/' + handle;
    }
  }

  /* ---------- עמוד מוצר: גלריה, וריאציה, כמות ופס קנייה דביק ---------- */
  function initProduct() {
    const wrap = $('[data-product]');
    const data = $('[data-product-json]');
    if (!wrap || !data) return;
    const product = JSON.parse(data.textContent);
    const form = $('[data-product-form]', wrap);
    const track = $('[data-track]', wrap), dots = $('[data-dots]', wrap), thumbs = $$('[data-thumb]', wrap);
    const slides = $$('[data-media-id]', track);
    let current = 0;

    /* גלריה: נקודות במובייל, תמונות קטנות במחשב, וחיצים */
    if (dots) dots.innerHTML = slides.length > 1 ? slides.map((_, i) => `<span aria-current="${i === 0}"></span>`).join('') : '';
    const mark = i => {
      current = i;
      $$('span', dots).forEach((d, k) => d.setAttribute('aria-current', String(k === i)));
      thumbs.forEach((t, k) => t.setAttribute('aria-current', String(k === i)));
    };
    if ('IntersectionObserver' in window && slides.length > 1) {
      const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) mark(slides.indexOf(en.target)); }), { root: track, threshold: 0.6 });
      slides.forEach(s => io.observe(s));
    }
    const go = i => {
      const s = slides[(i + slides.length) % slides.length];
      if (!s) return;
      // מיקום יחסי למסילה: עובד גם בכיוון מימין לשמאל, שבו scrollLeft שלילי
      track.scrollTo({ left: track.scrollLeft + s.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: reduced ? 'auto' : 'smooth' });
    };
    thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    const prev = $('[data-gallery-prev]', wrap), next = $('[data-gallery-next]', wrap);
    if (prev) prev.addEventListener('click', () => go(current - 1));
    if (next) next.addEventListener('click', () => go(current + 1));

    if (!form) return;
    const priceBox = $('.pdp__price', wrap);
    const cta = $('[data-main-cta]', form);
    const qtyInput = $('[data-qty-input]', form);

    /* קנו יותר, חסכו יותר: בחירת 1 / 2 / 3 יחידות קובעת את הכמות, ושינוי כמות מסמן את המדרגה המתאימה */
    const tiers = $$('[data-tier-qty]', form);
    const syncTier = q => { const t = tiers.slice().reverse().find(x => q >= Number(x.dataset.tierQty)); if (t) t.checked = true; };
    const tierPrices = variant => tiers.forEach(t => {
      const q = Number(t.dataset.tierQty), off = Number(t.dataset.tierOff), label = t.closest('.tier');
      // כמו בקופה: ההנחה מעוגלת כלפי מטה לכל יחידה
      $('[data-tier-price]', label).textContent = formatMoney((variant.price - Math.floor(variant.price * off / 100)) * q);
      const was = $('[data-tier-was]', label);
      if (was) was.textContent = formatMoney(variant.price * q);
    });
    tiers.forEach(t => t.addEventListener('change', () => { if (qtyInput) qtyInput.value = t.dataset.tierQty; }));

    /* כמות */
    $$('[data-step]', form).forEach(b => b.addEventListener('click', () => {
      const v = Math.max(1, Math.min(99, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.dataset.step, 10)));
      qtyInput.value = v;
      syncTier(v);
    }));
    if (qtyInput) qtyInput.addEventListener('input', () => syncTier(parseInt(qtyInput.value, 10) || 1));

    /* פס קנייה דביק במובייל */
    let bar = null;
    const updateBar = variant => {
      if (!bar) return;
      $('[data-bb-price]', bar).innerHTML = variant ? priceHTML(variant.price, variant.compare_at_price) : '';
      const b = $('button', bar);
      b.disabled = !variant || !variant.available;
      $('[data-bb-label]', bar).textContent = variant && variant.available ? S.addToCart : S.soldOut;
    };
    if (cta) {
      bar = document.createElement('div');
      bar.className = 'buybar';
      bar.innerHTML = `<div class="buybar__info"><strong>${esc(product.title)}</strong><span data-bb-price></span></div><button class="btn btn--primary" type="button">${ICON.bag} <span data-bb-label>${esc(S.addToCart)}</span></button>`;
      document.body.appendChild(bar);
      $('button', bar).addEventListener('click', () => cta.click());
      let ticking = false;
      const check = () => {
        ticking = false;
        const show = cta.getBoundingClientRect().bottom < 0;
        bar.classList.toggle('is-visible', show);
        document.body.classList.toggle('has-buybar', show);
      };
      window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
      window.addEventListener('resize', check);
      check();
    }

    /* קנו עכשיו: מוסיף לסל ועובר ישר לקופה (במקום כפתור PayPal של שופיפיי; בקופה האשראי ראשון) */
    const buyNow = $('[data-buy-now]', form);
    if (buyNow) {
      buyNow.addEventListener('click', async () => {
        const id = $('[data-variant-id]', form).value;
        if (!id || buyNow.disabled) return;
        buyNow.disabled = true;
        buyNow.classList.add('is-loading');
        try {
          await addItem(id, parseInt(qtyInput && qtyInput.value, 10) || 1);
          location.href = P.routes.root.replace(/\/?$/, '/') + 'checkout';
        } catch (e) {
          toast(e.message || S.error);
          buyNow.disabled = false;
          buyNow.classList.remove('is-loading');
        }
      });
      // חזרה מהקופה בכפתור "אחורה": הדף משוחזר מהזיכרון עם הכפתור במצב טעינה
      window.addEventListener('pageshow', () => { buyNow.classList.remove('is-loading'); buyNow.disabled = !!(cta && cta.disabled); });
    }

    /* תשלומים ללא ריבית לפי המחיר שישולם. בלאק פריידיי (data-bf-off, רק למוצר מהאוסף): בזמן המבצע לפי המחיר אחרי ההנחה,
       מעוגלת כלפי מטה כמו בקופה (זהה ל-sections/main-product) */
    const instSet = (inst, variant) => {
      const off = inst.dataset.bfOff != null && bfLive() ? Number(inst.dataset.bfOff) : 0;
      const price = variant.price - Math.floor(variant.price * off / 100);
      const n = price >= Number(inst.dataset.min) ? Number(inst.dataset.max) : (Number(inst.dataset.two) > 0 && price >= Number(inst.dataset.two) ? 2 : 0);
      inst.hidden = !n;
      if (n) { $('[data-inst-n]', inst).textContent = n; $('[data-inst-amount]', inst).textContent = formatMoney(Math.round(price / n)); }
    };
    const update = initPicker(form, product, variant => {
      if (variant) {
        if (priceBox) priceBox.innerHTML = priceHTML(variant.price, variant.compare_at_price, true);
        const inst = $('[data-inst]', wrap);
        if (inst) instSet(inst, variant);
        const rs = $('[data-restock]', wrap);
        if (rs) rs.hidden = !!variant.available;
        if (tiers.length) tierPrices(variant);
        try { history.replaceState(null, '', location.pathname + '?variant=' + variant.id); } catch (e) { /* ignore */ }
        const media = variant.featured_media;
        if (media) {
          const i = slides.findIndex(s => s.dataset.mediaId === String(media.id));
          if (i > -1) go(i);
        }
      }
      updateBar(variant);
      if (buyNow) buyNow.disabled = !variant || !variant.available;
    });
    form.addEventListener('submit', e => {
      e.preventDefault();
      const id = $('[data-variant-id]', form).value;
      if (id) addAndOpen(id, parseInt(qtyInput && qtyInput.value, 10) || 1, cta);
    });
    if ($$('[data-option-index]', form).length) update(); else updateBar(product.variants[0]);
    // בלאק פריידיי: עמוד מהמטמון מתוקן מיד לפי השעון בדפדפן, גם בלי בחירת וריאציה
    const instBf = $('[data-inst][data-bf-off]', wrap);
    if (instBf) instSet(instBf, product.variants.find(v => String(v.id) === ($('[data-variant-id]', form) || {}).value) || product.variants[0]);
  }

  /* ---------- בלאק פריידיי: מה מוצג ----------
     Liquid כבר סימן את המצב לפי שעון השרת; כאן מתקנים לפי השעון בדפדפן (עמוד מהמטמון של שופיפיי).
     data-bf-show = מוצג רק בזמן המבצע · data-bf-hide = מוסתר בזמן המבצע. פס ההודעות: בזמן המבצע רק הודעת המבצע */
  function applyBf() {
    if (!$('[data-bf-show], [data-bf-hide]')) return;
    const live = bfLive();
    $$('[data-bf-show]').forEach(el => { el.hidden = !live; });
    $$('[data-bf-hide]').forEach(el => { el.hidden = live; });
    const box = $('[data-announce]');
    if (box && $('[data-bf-show], [data-bf-hide]', box)) {
      const msgs = $$('.announce__msg', box);
      msgs.forEach(m => m.classList.remove('is-on'));
      const first = msgs.find(m => !m.hidden);
      if (first) first.classList.add('is-on');
    }
  }

  /* ---------- פס הודעות מתחלף (רק ההודעות שמוצגות) ---------- */
  function initAnnounce() {
    const msgs = $$('.announce__msg').filter(m => !m.hidden);
    if (msgs.length < 2 || reduced) return;
    let i = 0;
    setInterval(() => {
      msgs[i].classList.remove('is-on');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-on');
    }, 4500);
  }

  /* ---------- אירועים כלליים ---------- */
  document.addEventListener('click', e => {
    const t = e.target;
    const quick = t.closest('[data-quick]');
    if (quick) { e.preventDefault(); openQuick(quick.dataset.quick); return; }
    const add = t.closest('[data-add-variant]');
    if (add) { e.preventDefault(); addAndOpen(add.dataset.addVariant, 1, add); return; }
    const opener = t.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      const id = opener.dataset.open;
      if (id === 'cart') { refreshCart(true); return; }
      if (id === 'review') prepareReview(opener);
      openPanel(id);
      return;
    }
    if (t.closest('[data-close]') || t.closest('[data-overlay]')) { closePanels(); return; }
    const q = t.closest('[data-qty]');
    if (q) {
      const box = q.closest('[data-key]');
      const qty = parseInt($('span', box).textContent, 10) || 0;
      changeLine(box.dataset.key, Math.max(0, qty + parseInt(q.dataset.qty, 10))).then(renderCart).catch(() => toast(S.error));
      return;
    }
    const rm = t.closest('[data-remove]');
    if (rm) { changeLine(rm.dataset.remove, 0).then(renderCart).catch(() => toast(S.error)); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closePanels(); });

  /* מיון בעמוד קטגוריה */
  const sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', () => {
    const u = new URL(location.href);
    u.searchParams.set('sort_by', sort.value);
    u.searchParams.delete('page');
    location.href = u.toString();
  });

  /* "עדכנו אותי כשחוזר למלאי": הבקשה נשמרת בשירות קטן בענן, ומרכז הניהול שולח מייל אחד כשהאפשרות חוזרת */
  document.addEventListener('submit', async e => {
    const f = e.target.closest('[data-restock-form]');
    if (!f) return;
    e.preventDefault();
    const box = f.closest('[data-restock]'), input = $('input[type="email"]', f), err = $('[data-restock-error]', box);
    const mail = input.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(mail)) { err.hidden = false; input.focus(); return; }
    err.hidden = true;
    const pform = $('[data-product-form]');
    let product = {};
    try { product = JSON.parse($('[data-product-json]').textContent); } catch (x) { /* ignore */ }
    const btn = $('button', f);
    btn.disabled = true;
    try {
      const r = await fetch('https://shops-restock-notify.store-support-bot.workers.dev/subscribe', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ store: box.dataset.store, variant: $('[data-variant-id]', pform).value, product: String(product.id || ''), title: product.title || '', url: location.origin + location.pathname, email: mail, lang: P.locale === 'he' ? 'he' : 'en' }) });
      if (!r.ok) throw new Error(String(r.status));
      f.hidden = true;
      $('.restock__note', box).hidden = true;
      $('[data-restock-ok]', box).hidden = false;
    } catch (x) { toast(S.error); btn.disabled = false; }
  });

  /* מועדון: חובה לאשר קבלת דיוור לפני שליחה */
  document.addEventListener('submit', e => {
    const f = e.target.closest('[data-club-form]');
    if (!f) return;
    const email = $('input[type="email"]', f), consent = $('[data-club-consent]', f), err = $('[data-club-error]', f);
    let msg = '';
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim())) msg = S.clubEmail;
    else if (consent && !consent.checked) msg = S.clubConsent;
    if (msg) {
      e.preventDefault();
      if (err) { err.textContent = msg; err.hidden = false; }
    }
  });

  /* פוטר: פתוח במחשב, אקורדיון במובייל */
  const footMq = window.matchMedia('(max-width: 760px)');
  const syncFooter = () => $$('details.fcol').forEach(d => { d.open = !footMq.matches; });
  syncFooter();
  footMq.addEventListener('change', syncFooter);
  document.addEventListener('click', e => { if (!footMq.matches && e.target.closest('details.fcol > summary')) e.preventDefault(); });

  /* וואטסאפ צף מופיע אחרי גלילה קצרה */
  const onScroll = () => document.documentElement.classList.toggle('is-scrolled', window.scrollY > window.innerHeight * 0.5);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* כניסה עדינה בגלילה */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    $$('.reveal').forEach(el => io.observe(el));
    /* גלילה מהירה או קפיצה לעוגן: מה שכבר מעל קצה המסך מוצג מיד, כדי ששום דבר לא יישאר שקוף */
    let pending = false;
    window.addEventListener('scroll', () => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => {
        pending = false;
        $$('.reveal:not(.in)').forEach(el => { if (el.getBoundingClientRect().top < window.innerHeight) { el.classList.add('in'); io.unobserve(el); } });
      });
    }, { passive: true });
  } else {
    $$('.reveal').forEach(el => el.classList.add('in'));
  }

  /* תאריך יציאת ההזמנה */
  $$('[data-dispatch]').forEach(el => { el.textContent = dispatchDate(); });
  /* צפי הגעה בתאריכים במקום טווח ימים (החנויות המצליחות מציגות תאריכים): היום + טווח זמן האספקה, בימי עסקים א׳–ה׳ */
  $$('[data-arrival]').forEach(el => {
    const m = /(\d+)\D+(\d+)/.exec(el.dataset.range || '');
    if (!m) return;
    const add = n => { const d = new Date(); let k = 0; while (k < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 5 && d.getDay() !== 6) k++; } return d; };
    const f = d => P.locale === 'he' ? d.getDate() + '.' + (d.getMonth() + 1) : d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
    el.textContent = (P.locale === 'he' ? 'צפי הגעה: ' : 'Estimated arrival: ') + f(add(+m[1])) + '–' + f(add(+m[2]));
    /* שורות "מומלץ להזמין עד" לחגים (בלי טיימרים, אף פעם לא הבטחת הגעה), כל אחת נעלמת לבד אחרי התאריך שלה:
       חנוכה (נר ראשון): היום האחרון שהזמנה בו מגיעה עד 3.12 גם בזמן האספקה הארוך ביותר;
       ושורות בתאריכים קבועים מ-snippets/order-by.liquid (סוף חנוכה וסילבסטר בישראל; חג המולד וסילבסטר בחו"ל),
       כל אחת מוצגת מהיום הראשון שלה ועד היום האחרון שלה */
    const notes = [];
    if (P.locale === 'he') {
      const d = new Date(2026, 11, 3); let k = 0;
      while (k < +m[2]) { d.setDate(d.getDate() - 1); if (d.getDay() !== 5 && d.getDay() !== 6) k++; }
      const today = new Date(); today.setHours(0, 0, 0, 0);
      if (today <= d) notes.push('🎁 רוצים שיגיע לפני חנוכה? מומלץ להזמין עד יום ' + 'אבגדהוש'[d.getDay()] + '׳, ' + d.getDate() + '.' + (d.getMonth() + 1));
    }
    let more = [];
    try { const ob = $('[data-order-by]'); more = ob ? JSON.parse(ob.textContent) : []; } catch (e) { more = []; }
    // הטקסט מגיע מקודד ל-HTML (מסנן התרגום): מפענחים, ואז מקודדים בטוח
    const now = Date.now();
    more.forEach(o => { if (now >= (o.from || 0) && now <= o.until) { decoder.innerHTML = o.text; notes.push(esc(decoder.value)); } });
    if (notes.length) el.insertAdjacentHTML('afterend', notes.map(t => '<br><span class="holiday-note">' + t + '</span>').join(''));
  });

  /* ---------- כתיבת ביקורת: מוצר מסוים או ביקורת כללית, דירוג בכוכבים ובדיקת שדות ---------- */
  const reviewForm = $('[data-review-form]');
  function syncReviewType() {
    if (!reviewForm) return;
    const general = $('[data-review-type="general"]', reviewForm).checked;
    $('[data-review-product-field]', reviewForm).hidden = general;
    $('[data-review-product]', reviewForm).disabled = general;
  }
  function prepareReview(opener) {
    if (!reviewForm) return;
    const handle = opener.dataset.reviewProduct;
    const type = $(`[data-review-type="${opener.hasAttribute('data-review-general') ? 'general' : 'product'}"]`, reviewForm);
    if (type) type.checked = true;
    if (handle) {
      // ברשימה יש רק חלק מהמוצרים (שופיפיי מחזיר עד 50): מוצר שחסר נוסף לראש הרשימה
      const sel = $('[data-review-product]', reviewForm);
      let opt = $$('option', sel).find(o => o.dataset.handle === handle);
      if (!opt && opener.dataset.reviewTitle) {
        opt = new Option(opener.dataset.reviewTitle, opener.dataset.reviewTitle);
        opt.dataset.handle = handle;
        sel.prepend(opt);
      }
      if (opt) opt.selected = true;
    }
    syncReviewType();
  }
  if (reviewForm) {
    const stars = $$('.star-input__star', reviewForm);
    const paint = n => stars.forEach((s, i) => s.classList.toggle('is-on', i < n));
    const selected = () => stars.findIndex(s => $('input', s).checked) + 1;
    stars.forEach((s, i) => s.addEventListener('mouseenter', () => paint(i + 1)));
    $('.star-input__row', reviewForm).addEventListener('mouseleave', () => paint(selected()));
    reviewForm.addEventListener('change', e => {
      if (e.target.matches('[data-review-type]')) syncReviewType();
      if (e.target.name === 'contact[דירוג]') paint(selected());
    });
    syncReviewType();
  }
  document.addEventListener('submit', e => {
    const f = e.target.closest('#pt-review');
    if (!f) return;
    const err = $('[data-review-error]', f);
    const email = $('#pt-review-email', f).value.trim();
    let msg = '';
    if (!$('input[name="contact[דירוג]"]:checked', f)) msg = S.reviewRating;
    else if (!$('#pt-review-name', f).value.trim() || !$('#pt-review-body', f).value.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) msg = S.reviewFields;
    if (msg) {
      e.preventDefault();
      err.textContent = msg;
      err.hidden = false;
    }
  });

  /* ---------- אחרי שליחת טופס יצירת קשר ----------
     פנייה וביקורת הן שתיהן טפסי יצירת קשר, ושופיפיי מסמנת את כולן כ"נשלחו".
     לכן זוכרים איזה טופס נשלח, ומציגים הצלחה או שגיאה רק בו ופותחים את המגירה שלו. */
  document.addEventListener('submit', e => {
    const f = e.target.closest('[data-contact-form]');
    if (f && !e.defaultPrevented) { try { sessionStorage.setItem('pt-contact-form', f.id); } catch (x) { /* ignore */ } }
  });
  const contactForms = $$('[data-contact-form]');
  if (contactForms.some(f => $('[data-form-success]', f) || ($('[data-form-error]', f) && $('[data-form-error]', f).textContent.trim()))) {
    let posted = '';
    try { posted = sessionStorage.getItem('pt-contact-form') || ''; sessionStorage.removeItem('pt-contact-form'); } catch (x) { /* ignore */ }
    if (!posted && /^#pt-/.test(location.hash)) posted = location.hash.slice(1);
    let opened = false;
    contactForms.forEach(f => {
      const mine = !posted || f.id === posted;
      const done = $('[data-form-success]', f), err = $('[data-form-error]', f), fields = $('[data-form-fields]', f);
      if (done && mine) { done.hidden = false; if (fields) fields.hidden = true; }
      if (done && !mine) done.remove();
      if (err && !mine) { err.hidden = true; err.textContent = ''; }
      const panel = f.closest('.drawer');
      if (mine && !opened && panel && (done || (err && err.textContent.trim()))) { openPanel(panel.id); opened = true; }
    });
  }
  if ($('#club [data-club-success]')) openPanel('club');

  /* ---------- כותרת עמודי המדיניות: השם שלנו במקום השם הכללי של שופיפיי ---------- */
  const policy = (location.pathname.match(/\/policies\/([a-z-]+)/) || [])[1];
  const policyTitle = policy && (S.policyTitles || {})[policy];
  const policyH1 = policyTitle && $('.shopify-policy__title h1');
  if (policyH1) policyH1.textContent = policyTitle;

  /* ---------- עוגיות: שופיפיי מוסיפה בדפדפן קישור "קובצי cookie" לפוטר; מוצג רק אם אין לנו דף מדיניות עוגיות ---------- */
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href$="#cookie-preferences"]');
    if (!a || !window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') return;
    e.preventDefault();
    window.privacyBanner.showPreferences();
  });

  /* ---------- חיפוש בכותרת: הצעות מוצרים תוך כדי הקלדה (Predictive Search API) ---------- */
  function initSearch() {
    const form = $('[data-psearch]');
    if (!form) return;
    const input = $('[data-psearch-input]', form), box = $('[data-psearch-results]', form);
    const toggle = $('[data-search-toggle]'), header = form.closest('.header');
    let timer = 0, ctrl = null, active = -1;
    const close = () => { box.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; };
    const items = () => $$('.psearch__item, .psearch__all', box);
    const mark = i => { items().forEach((el, j) => el.setAttribute('aria-selected', j === i ? 'true' : 'false')); active = i; };
    async function suggest(q) {
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      try {
        const url = (P.routes.suggest || '/search/suggest') + '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag';
        const r = await fetch(url, { signal: ctrl.signal, headers: { Accept: 'application/json' } }).then(x => x.json());
        const list = ((r.resources || {}).results || {}).products || [];
        const all = (P.routes.search || '/search') + '?type=product&options[prefix]=last&q=' + encodeURIComponent(q);
        box.innerHTML = (list.length ? list.map(p => `<a class="psearch__item" role="option" href="${esc(p.url)}">` +
          `<span class="psearch__img">${p.image ? `<img src="${esc(sized(p.image, 120))}" alt="" loading="lazy" width="56" height="56">` : ''}</span>` +
          `<span><span class="psearch__title">${esc(p.title)}</span><span class="psearch__price">${formatMoney(Math.round(parseFloat(p.price) * 100))}</span></span></a>`).join('')
          : `<p class="psearch__none">${esc(S.searchNone)}</p>`) +
          `<a class="psearch__all" role="option" href="${esc(all)}">${esc(S.searchAll || '').replace('__TERMS__', esc(q))}</a>`;
        box.hidden = false; input.setAttribute('aria-expanded', 'true'); active = -1;
      } catch (e) { if (e.name !== 'AbortError') close(); }
    }
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { close(); return; }
      timer = setTimeout(() => suggest(q), 220);
    });
    input.addEventListener('keydown', e => {
      const list = items();
      if (box.hidden || !list.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); mark((active + 1) % list.length); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); mark(active <= 0 ? list.length - 1 : active - 1); }
      else if (e.key === 'Enter' && active > -1) { e.preventDefault(); location.href = list[active].href; }
      else if (e.key === 'Escape') close();
    });
    input.addEventListener('focus', () => { if (box.innerHTML && input.value.trim().length > 1) { box.hidden = false; input.setAttribute('aria-expanded', 'true'); } });
    document.addEventListener('click', e => { if (!form.contains(e.target) && !(toggle && toggle.contains(e.target))) close(); });
    if (toggle && header) toggle.addEventListener('click', () => {
      const on = header.classList.toggle('is-search');
      toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) input.focus(); else close();
    });
  }

  applyBf();
  initAnnounce();
  initSearch();
  initProduct();
  refreshCart(false);
})();

// a language chosen with the language button wins over the automatic choice by country (snippets/geo-lang.liquid)
document.addEventListener('submit', function (e) { if (e.target && e.target.classList && e.target.classList.contains('lang-form')) { try { localStorage.setItem('pellena_lang', 'manual'); } catch (err) {} } }, true);
